import { render, staticRenderFns } from "./DenominationsTable.vue?vue&type=template&id=d72babc2&scoped=true"
import script from "./DenominationsTable.vue?vue&type=script&lang=ts"
export * from "./DenominationsTable.vue?vue&type=script&lang=ts"
import style0 from "./DenominationsTable.vue?vue&type=style&index=0&id=d72babc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72babc2",
  null
  
)

export default component.exports